import { render, staticRenderFns } from "./withdraw-deposit.vue?vue&type=template&id=3073be9f&scoped=true&"
import script from "./withdraw-deposit.vue?vue&type=script&lang=js&"
export * from "./withdraw-deposit.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-deposit.vue?vue&type=style&index=0&id=3073be9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3073be9f",
  null
  
)

export default component.exports